import React from 'react'

import TRANSPARENT_PNG from '../icones/TRANSPARENT_PNG'

import './SVGLoader.scss'

const DEFAULT_FALLBACK = 'icones/settings.png'

function SVGLoader({ imagem, fallback = DEFAULT_FALLBACK, className, ...props }) {
    const imgUrl = `${imagem}`

    if (!imgUrl.match(/\.svg$/gi)) {
        return <img alt="imagem" className={`${className || ''}`} src={`${imgUrl || fallback}`} />
    }

    const onLoad = event => {
        event.persist()

        fetch(imgUrl)
            .then(response => (response.status !== 200 ? new Error() : response.text()))
            .then(svgContent => {
                const document = new DOMParser().parseFromString(svgContent, 'text/html')
                const svg = document.querySelector('svg')

                ;`${className || ''}`
                    .trim()
                    .split(/\s+/gi)
                    .map(classname => (svg ? svg.classList.add(classname) : ''))

                if (svg !== null) {
                    event.target.parentNode.replaceChild(svg, event.target)
                }
            })
            .catch(error => (console.error(error), (event.target.src = fallback)))
    }

    return (
        <i className={`transparencia-portal-dynamic-svg-loader ${className || ''}`} {...props}>
            <img className="transparent_png" onLoad={onLoad} src={TRANSPARENT_PNG} />
        </i>
    )
}

export default SVGLoader
